// TODO: Please see also: SortOrder - color-picker.component.ts - where it has used asc / desc with small caps - not sure yet if need to change that enums seperately
export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

export type SortDirectionType = SortDirection;
